export default __webpack_public_path__ + "static/IFF-576a1d657706cc84194d433d5dc87d63.png";